import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";
import TransmedGalleryServer from "../../server/transmed_gallery";
import {
  OutputTransmedGalleryEntry,
  RequestGalleryEntriesByCounty,
} from "../../dtos/transmed/gallery";

class TransmedGalleryServiceReader extends ServiceReader {
  constructor(protected api: TransmedGalleryServer) {
    super();
  }

  public async byCounty(
    countyName: string
  ): Promise<OutputTransmedGalleryEntry[]> {
    const raw = await this.api.get(
      new RequestGalleryEntriesByCounty(countyName)
    );
    if (!Array.isArray(raw))
      throw new TypeError("Transmed Gallery is not an array.");

    return raw.map((value) => OutputTransmedGalleryEntry.convert(value));
  }
}

class TransmedGalleryServiceCreator extends ServiceCreator {}
class TransmedGalleryServiceUpdater extends ServiceUpdater {}
class TransmedGalleryServiceDeleter extends ServiceDeleter {}

export default class TransmedGalleryService extends Service {
  constructor() {
    super(new TransmedGalleryServer());
  }

  public get read(): TransmedGalleryServiceReader {
    return new TransmedGalleryServiceReader(this.api as TransmedGalleryServer);
  }
  public get create(): ServiceCreator {
    return new TransmedGalleryServiceCreator();
  }
  public get update(): ServiceUpdater {
    return new TransmedGalleryServiceUpdater();
  }
  public get delete(): ServiceDeleter {
    return new TransmedGalleryServiceDeleter();
  }
}
